import { render, staticRenderFns } from "./notifications-default-type.vue?vue&type=template&id=b13d55a0&"
import script from "./notifications-default-type.vue?vue&type=script&lang=js&"
export * from "./notifications-default-type.vue?vue&type=script&lang=js&"
import style0 from "./notifications-default-type.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports